import React, { FC } from "react";
import ReactPaginate from "react-paginate";
import classnames from "classnames";

import { IPaginationProps } from "./types";
import Icon from "../Icon";
import { IconName } from "../Icon/types";
import Rows from "./Rows";
import { PAGE_SIZES } from "./constants";

import "./styles.scss";

export const Pagination: FC<IPaginationProps> = ({
  className,
  page,
  pages,
  pageSizes,
  onPageSizeChange,
  onPageChange,
}) => {
  const left: IconName = "left";
  const right: IconName = "right";

  const handlePageChange = (selectedItem: { selected: number }) => {
    onPageChange(selectedItem.selected);
  };

  return (
    <div className={classnames("ams-pagination-section", className)}>
      {pages ? (
        <ReactPaginate
          forcePage={page}
          previousLabel={<Icon>{left}</Icon>}
          nextLabel={<Icon>{right}</Icon>}
          breakLabel="..."
          breakClassName="ams-break"
          pageCount={pages}
          marginPagesDisplayed={1}
          pageRangeDisplayed={5}
          onPageChange={handlePageChange}
          containerClassName="ams-pagination"
          pageClassName="ams-pagination__page"
          pageLinkClassName="ams-pagination__link"
          activeClassName="ams-pagination__link__active"
          nextClassName="ams-next"
          previousClassName="ams-previous"
          disabledClassName="ams-disabled"
        />
      ) : null}
      <Rows
        pageSizes={pageSizes as number[]}
        onPageSizeChange={onPageSizeChange}
      />
    </div>
  );
};

Pagination.defaultProps = {
  pageSizes: PAGE_SIZES,
};
